var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79057 3.51896C8.32218 3.37078 7.78354 3.272 7.29173 3.272C6.68283 3.272 5.37135 3.69183 5.37135 4.5068V6.4578H8.48612V9.74238H5.37135V18.8059H2.23317V9.74238H0.6875V6.4578H2.23317V4.80316C2.23317 2.30885 3.31046 0.234375 5.91 0.234375C6.79993 0.234375 8.39244 0.283767 9.25895 0.604817L8.79057 3.51896Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook Icon.a393df6143da2722b129a3be64cd4aed.svg";
export { ForwardRef as ReactComponent };